<template>
  <div class="filter-wrapper rounded overflow-hidden bg-white border mb-3 no-print">
    <div class="d-flex justify-content-center align-items-center bg-light p-3">
      <font-awesome-icon
        :icon="['fas', 'filter']"
        class="mr-1"
      ></font-awesome-icon>
      <span>Filtros</span>
    </div>
    <div class="p-3">
      <div class="row mb-3">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Tag Ambra</label>
                <input
                  type="text"
                  v-model="filters.ambra_tag"
                  class="form-control form-control-sm"
                />
              </div>

              <div class="form-group mb-1">
                <label>Tag do equipamento</label>
                <input
                  type="text"
                  v-model="filters.machine_tag"
                  class="form-control form-control-sm"
                />
              </div>

              <div class="form-group mb-1">
                <label>Equipamento</label>

                <Dropdown
                  v-model="filters.machine_class_id"
                  :options="non_paginated_machine_classes"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder=""
                  filter-placeholder=""
                  data-key="id"
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Setor</label>

                <Dropdown
                  v-model="filters.sector_name"
                  :options="company_sectors"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                  @change="onChangeSector"
                />
              </div>

              <div class="form-group mb-1">
                <label>Área</label>

                <Dropdown
                  v-model="filters.area_name"
                  :options="company_areas"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                  @change="onChangeArea"
                />
              </div>

              <div class="form-group mb-1">
                <label>Complemento</label>

                <Dropdown
                  v-model="filters.complement_name"
                  :options="company_complements"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Id (de)</label>
                <input
                  type="text"
                  v-model="filters.id_from"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group mb-1">
                <label>Id (até)</label>
                <input
                  type="text"
                  v-model="filters.id_to"
                  class="form-control form-control-sm"
                />
              </div>
              <div class="form-group mb-1">
                <label>Id do equipamento</label>
                <input
                  type="text"
                  v-model="filters.machine_id"
                  class="form-control form-control-sm"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Status Equip.</label>
                <select
                  v-model="filters.machine_status"
                  class="form-control form-control-sm"
                >
                  <option value="" selected>Todos</option>
                  <option value="active">Ativos</option>
                  <option value="inactive">Inativos</option>
                </select>
              </div>

              <div class="form-group mb-1">
                <label>Ordenar Por</label>
                <select
                  v-model="filters.order_by"
                  class="form-control form-control-sm"
                >
                  <option value="1" selected>ID (crescente)</option>
                  <option value="2">ID (decrescente)</option>
                  <option value="3">Tag Ambra (crescente)</option>
                  <option value="4">Tag Ambra (decrescente)</option>
                </select>
              </div>

              <div class="form-group mb-1">
                <label>Pesquisar texto</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="d-flex flex-column h-100 align-items-center">
            <div class="mt-auto">
              <button class="btn btn-success mb-2 w-100" @click="onFilter">
                <font-awesome-icon
                  :icon="['fas', 'filter']"
                ></font-awesome-icon>
                Filtrar
              </button>
              <button class="btn btn-primary mb-2 w-100" @click="print">
                <font-awesome-icon
                  :icon="['fas', 'print']"
                ></font-awesome-icon>
                Salvar / Imprimir
              </button>
              <!-- <button class="btn btn-primary mb-2 w-100">
								<font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
								Imprimir
							</button> -->
              <modal-extract></modal-extract>
              <button class="btn btn-secondary mb-1 w-100" @click="clearFilter">
                <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
                Limpar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import Dropdown from 'primevue/dropdown'

  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useCompanySectors from '@/modules/CompanySector.js'
  import useMachineClasses from '@/modules/MachineClass.js'
  import useMachines from '@/modules/Machine.js'

  import ModalExtract from '@/components/risk-analyses/components/ModalExtract.vue'

  export default {
    components: { ModalExtract, Dropdown },
    setup() {
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)

      const {
        filtered_company_areas,
        listCompanyAreasBySector,
        clearFilteredCompanyAreas,
      } = useCompanyAreas()
      const {
        filtered_company_complements,
        listCompanyComplementsByArea,
        clearFilteredCompanyComplements,
      } = useCompanyComplements()
      const { filtered_company_sectors, listCompanySectors } =
        useCompanySectors()
      const { non_paginated_machine_classes, listMachineClassesNoPagination } =
        useMachineClasses()
      const { inventory_filters, listInventory } = useMachines()

      onMounted(async () => {
        listCompanySectors(selected_company.value.id)
        listMachineClassesNoPagination()
      })

      const onFilter = () => {
        listInventory(selected_company.value.id, 1, 10)
      }

      const clearFilter = () => {
        inventory_filters.value = {}
        onFilter()
      }

      const onChangeSector = () => {
        inventory_filters.value.area_name = null
        inventory_filters.value.complement_name = null
        clearFilteredCompanyAreas()
        clearFilteredCompanyComplements()

        listCompanyAreasBySector(inventory_filters.value.sector_name)
      }

      const onChangeArea = () => {
        inventory_filters.value.complement_name = null
        clearFilteredCompanyComplements()

        listCompanyComplementsByArea(inventory_filters.value.area_name)
      }

      const print = () => {
        window.print()
      }

      return {
        company_areas: filtered_company_areas,
        company_complements: filtered_company_complements,
        company_sectors: filtered_company_sectors,
        non_paginated_machine_classes,
        filters: inventory_filters,
        clearFilter,
        onFilter,
        onChangeSector,
        onChangeArea,
        print,
      }
    },
  }
</script>

<style lang="scss" scoped>
  label {
    margin: 0;
    font-size: 0.7rem;
  }

  input,
  select,
  .p-dropdown {
    height: 30px;

    font-size: 0.8rem;
  }

  .p-dropdown {
    width: 100%;
  }

  ::v-deep(.p-dropdown) {
    .p-dropdown-label,
    .p-inputtext {
      font-size: 0.8rem !important;
      height: 30px;
      // padding: 0.3rem 1rem !important;
      color: #495057 !important;
    }

    .p-dropdown-trigger {
      margin-right: -5px;
    }

    .pi {
      font-size: 0.65rem;
      font-weight: bolder;
    }
  }
</style>
